var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimBackgroundMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 315,
    viewBox: "0 0 390 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_527",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1325,
    y: 0,
    width: 1920,
    height: 315
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1325,
    width: 1920,
    height: 315,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_527)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_527)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2160,
    height: 900.993,
    transform: "translate(-692 -299)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1373.71 -179.113H-566.606V325.982H1373.71V-179.113Z",
    fill: "url(#paint0_linear_40_527)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.45,
    d: "M111.183 76.0418L275.697 267.424V-73.5642L111.183 76.0418Z",
    fill: "url(#paint1_linear_40_527)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.21,
    d: "M26.2617 -62.7128L85.2764 141.525L244.333 -174.013L26.2617 -62.7128Z",
    fill: "url(#paint2_linear_40_527)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.21,
    d: "M304.227 303.661L368.439 487.858L474.77 163.163L304.227 303.661Z",
    fill: "url(#paint3_linear_40_527)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.22,
    d: "M338.72 -134.159L211.452 82.3473L518.958 -64.9939L338.72 -134.159Z",
    fill: "url(#paint4_linear_40_527)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.17,
    d: "M385.091 126.258L232.911 153.827L410.444 245.363L385.091 126.258Z",
    fill: "url(#paint5_linear_40_527)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.45,
    d: "M292.594 413.608L232.178 237.395L175.64 379.686L292.594 413.608Z",
    fill: "url(#paint6_linear_40_527)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.45,
    d: "M159.656 -12.6758H-54.4233L199.526 214.878L159.656 -12.6758Z",
    fill: "url(#paint7_linear_40_527)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.21,
    d: "M-124.712 168.458L-21.3634 424.297L46.9874 125.899L-124.712 168.458Z",
    fill: "url(#paint8_linear_40_527)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.21,
    d: "M133.408 137.728L-0.100586 59.683L75.1912 244.695L133.408 137.728Z",
    fill: "url(#paint9_linear_40_527)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.21,
    d: "M-53.9668 125.899L55.6552 52.6931L-46.0971 -28.1222L-53.9668 125.899Z",
    fill: "url(#paint10_linear_40_527)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.86
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5933 -25.7192C68.5933 -25.7192 68.7596 -25.5945 68.809 -25.5163C68.9749 -25.2709 68.9916 -24.9587 68.8276 -24.7073L-9.72345 100.885C-9.86257 101.115 -10.1184 101.238 -10.3773 101.227L-109.343 96.0599L-137.176 157.271C-137.254 157.441 -137.39 157.565 -137.553 157.635L-247.824 206.474C-248.013 206.565 -248.24 206.561 -248.427 206.472L-400.213 135.942L-561.628 186.734C-561.866 186.808 -562.132 186.768 -562.326 186.59L-654.227 106.666L-720.474 44.6425C-720.672 44.4503 -720.76 44.1555 -720.66 43.8898C-720.574 43.6276 -720.339 43.4191 -720.062 43.381L-535.199 18.4154C-534.951 18.3843 -534.717 18.4773 -534.554 18.6481L-467.312 94.1799L-301.182 43.2051C-300.912 43.1386 -300.643 43.1928 -300.445 43.385L-247.628 96.9378L-197.605 73.9294C-197.456 73.8625 -197.293 73.8524 -197.133 73.8884L-110.146 94.4502L-49.6213 -0.0656903C-49.5107 -0.228502 -49.3436 -0.345014 -49.159 -0.390512L68.0474 -25.8558C68.232 -25.9013 68.4235 -25.8581 68.5828 -25.7618L68.5933 -25.7192ZM-10.7271 99.7461L66.6648 -24.0087L-48.5429 1.00927L-108.515 94.6508L-10.7271 99.7461ZM-138.393 156.426L-110.832 95.8243L-197.209 75.4136L-247.463 98.5241C-247.747 98.6544 -248.077 98.6 -248.285 98.3652L-301.159 44.7661L-467.318 95.7479C-467.584 95.8286 -467.889 95.7531 -468.08 95.529L-535.382 19.9367L-718.335 44.6426L-653.24 105.594L-561.669 185.223L-400.367 134.459C-400.197 134.417 -400.002 134.414 -399.846 134.496L-248.11 205.008L-138.397 156.412L-138.393 156.426Z",
    fill: "url(#paint11_linear_40_527)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.032 -87.036C139.369 -86.8326 139.488 -86.4101 139.302 -86.063L32.574 112.364C32.4063 112.662 32.0652 112.806 31.7427 112.72L-10.1613 101.309L-85.9381 161.2C-86.0769 161.309 -86.258 161.369 -86.4424 161.354L-137.451 157.746L-199.892 254.753C-200.014 254.933 -200.209 255.057 -200.429 255.081C-200.649 255.105 -200.865 255.023 -201.025 254.866L-248.368 206.593L-305.658 214.535C-305.86 214.57 -306.073 214.502 -306.225 214.374L-399.983 136.263L-441.223 198.82C-441.223 198.82 -441.341 198.954 -441.416 199.018L-493.084 235.764C-493.34 235.947 -493.674 235.939 -493.928 235.761L-562.263 186.665C-562.263 186.665 -562.337 186.608 -562.362 186.569L-653.972 106.904L-784.094 119.328C-784.388 119.356 -784.668 119.199 -784.809 118.932C-784.95 118.666 -784.91 118.339 -784.707 118.124L-720.489 43.6671C-720.311 43.4726 -720.048 43.3777 -719.793 43.4353L-615.453 64.4809L-535.715 18.7084L-494.99 -146.43C-494.932 -146.686 -494.726 -146.887 -494.474 -146.964C-494.218 -147.027 -493.945 -146.959 -493.761 -146.763L-384.878 -35.216L-333.675 -95.3026C-333.522 -95.4759 -333.305 -95.5745 -333.074 -95.556C-332.844 -95.5374 -332.635 -95.4232 -332.511 -95.2277L-272.634 -5.93494L-150.115 -78.4296C-149.931 -78.5354 -149.725 -78.556 -149.516 -78.5021C-149.321 -78.4446 -149.147 -78.2915 -149.07 -78.0997L-124.948 -23.6214L23.0232 -126.763C23.3575 -126.996 23.8148 -126.913 24.0478 -126.579C24.2808 -126.244 24.1977 -125.787 23.8635 -125.554L-124.844 -21.9146C-125.025 -21.7946 -125.256 -21.7528 -125.465 -21.8068C-125.674 -21.8607 -125.848 -22.0138 -125.943 -22.2163L-150.093 -76.748L-272.494 -4.32747C-272.821 -4.12636 -273.253 -4.23066 -273.469 -4.55422L-333.201 -93.6266L-384.302 -33.6709C-384.43 -33.5188 -384.633 -33.4236 -384.828 -33.4208C-385.037 -33.4144 -385.235 -33.486 -385.38 -33.6461L-493.902 -144.83L-534.401 19.3336C-534.444 19.525 -534.569 19.6913 -534.739 19.7936L-613.305 64.8854L-467.398 94.3218C-467.129 94.3759 -466.913 94.5788 -466.836 94.831C-466.769 95.1008 -466.838 95.3738 -467.033 95.5576L-560.707 185.95L-493.508 234.226L-442.377 197.869L-400.762 134.752C-400.655 134.575 -400.456 134.466 -400.254 134.431C-400.052 134.397 -399.842 134.45 -399.687 134.593L-305.547 213.031L-248.214 205.078C-247.979 205.051 -247.749 205.13 -247.59 205.286L-200.629 253.172L-138.451 156.561C-138.311 156.331 -138.056 156.208 -137.779 156.23L-86.6289 159.864L-10.774 99.9236C-10.5996 99.7751 -10.3547 99.7299 -10.1279 99.7945L31.567 111.151L138.017 -86.7556C138.213 -87.1203 138.65 -87.243 139.011 -87.0609C139.011 -87.0609 139.029 -87.0502 139.046 -87.0395L139.032 -87.036ZM-561.593 184.798L-469.052 95.4976L-614.118 66.2308L-561.607 184.801L-561.593 184.798ZM-563.834 183.346L-615.862 65.8773L-719.681 44.9292L-782.421 117.681L-653.804 105.387C-653.598 105.366 -653.417 105.427 -653.247 105.566L-563.837 183.332L-563.834 183.346Z",
    fill: "url(#paint12_linear_40_527)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-48.6133 -0.253675C-48.6133 -0.253675 -48.4646 -0.139653 -48.3975 -0.0507413L32.5198 111.594C32.7528 111.929 32.6839 112.383 32.3497 112.616C32.0154 112.849 31.5616 112.78 31.3321 112.46L-46.2801 5.36276L-9.65404 100.25C-9.52044 100.609 -9.68856 101.027 -10.0403 101.189L-137.546 157.664C-137.912 157.83 -138.344 157.665 -138.51 157.299C-138.675 156.933 -138.511 156.501 -138.131 156.332L-11.2642 100.135L-49.6699 0.654513C-49.8 0.309974 -49.6533 -0.0726755 -49.3369 -0.256087C-49.0988 -0.390097 -48.8257 -0.382069 -48.6098 -0.239452L-48.6133 -0.253675Z",
    fill: "url(#paint13_linear_40_527)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4454 110.909C33.8328 109.523 32.1995 108.886 30.8174 109.513C29.4319 110.126 28.7949 111.759 29.4217 113.141C30.0344 114.527 31.6676 115.164 33.0497 114.537C34.4353 113.924 35.0722 112.291 34.4454 110.909Z",
    fill: "url(#paint14_linear_40_527)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34705 74.6937C7.70272 73.2406 6.00565 72.5893 4.54906 73.2194C3.09597 73.8637 2.44464 75.5608 3.07476 77.0174C3.71909 78.4705 5.41617 79.1218 6.86926 78.4775C8.32235 77.8332 8.97368 76.1361 8.34355 74.6795L8.34705 74.6937Z",
    fill: "url(#paint15_linear_40_527)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40_527",
    x1: -150.603,
    y1: -480.72,
    x2: 951.287,
    y2: 621.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#00A4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#006B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#00497E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003C73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40_527",
    x1: 111.183,
    y1: -299,
    x2: 275.697,
    y2: -299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6AB0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4665A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2B2E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1B0C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40_527",
    x1: 55.7202,
    y1: 8.92929,
    x2: 204.153,
    y2: -25.3194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6AB0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4665A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2B2E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1B0C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_40_527",
    x1: 304.227,
    y1: 325.51,
    x2: 474.77,
    y2: 325.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6AB0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4665A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2B2E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1B0C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_40_527",
    x1: 294.748,
    y1: 130.542,
    x2: 435.409,
    y2: -113.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6AB0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4665A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2B2E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1B0C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_40_527",
    x1: 354.373,
    y1: 116.616,
    x2: 322.364,
    y2: 217.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6AB0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4665A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2B2E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1B0C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_40_527",
    x1: 302.44,
    y1: 403.895,
    x2: 185.008,
    y2: 283.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6AB0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4665A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2B2E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1B0C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_40_527",
    x1: 167.864,
    y1: -5.45363,
    x2: 72.5209,
    y2: 100.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6AB0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4665A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2B2E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1B0C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_40_527",
    x1: -143.039,
    y1: 222.107,
    x2: 27.5571,
    y2: 280.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6AB0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4665A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2B2E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1B0C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_40_527",
    x1: 114.367,
    y1: 107.61,
    x2: 24.4181,
    y2: 163.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6AB0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4665A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2B2E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1B0C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_40_527",
    x1: -66.7122,
    y1: 116.687,
    x2: 9.2874,
    y2: 12.2358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6AB0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4665A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2B2E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1B0C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_40_527",
    x1: -697.759,
    y1: 112.018,
    x2: -7.17451,
    y2: 87.4202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00427F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_40_527",
    x1: -699.38,
    y1: 66.5822,
    x2: -8.78841,
    y2: 41.9716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00427F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_40_527",
    x1: -698.183,
    y1: 100.225,
    x2: -7.71714,
    y2: 75.6238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00427F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_40_527",
    x1: -696.845,
    y1: 137.987,
    x2: -6.25269,
    y2: 113.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00427F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_40_527",
    x1: -698.155,
    y1: 100.942,
    x2: -7.57594,
    y2: 76.3236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00427F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2160,
    height: 900.993,
    fill: "white",
    transform: "translate(-692 -299)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimBackgroundMobile);
export default __webpack_public_path__ + "static/media/claim_background_mobile.25d14fcd03a0872bec6cfff3d9586b71.svg";
export { ForwardRef as ReactComponent };